import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import {
  getScale,
  schemeOneTotalCost,
} from '../../../utils/functions/vod-assessment';
import AssessmentResult, {
  IAssessment,
} from './AssessmentTemplates/AssessmentResult';
import BusinessForm, { FeeTypes } from './AssessmentTemplates/BusinessForm';
interface IProps {
  targetQuality: string;
  originQuality: string;
  scene: string;
  videoConfigs: any;
}

const BusinessDataConfig = ({
  targetQuality,
  originQuality,
  scene,
  videoConfigs,
}: IProps) => {
  const [formData, setFormData] = useState({
    feeType: FeeTypes.monthBandWidth95,
    videoNumber: 100000,
    videoDuration: 3,
    monthBandWidth95: 200000,
    flow: 2000000,
  });

  const [assessmentOne, setAssessmentOne] = useState({} as IAssessment);
  const [assessmentTwo, setAssessmentTwo] = useState({} as IAssessment);
  const getAssessmentResult = (formData) => {
    if (formData) {
      // 方案 1
      const schemeOneCost = schemeOneTotalCost(
        scene,
        targetQuality,
        originQuality,
        formData,
        videoConfigs
      );
      // console.log('schemeOneCost', schemeOneCost);
      // 方案1 的节约比例和收益
      const originCost =
        schemeOneCost.cdn.originCost +
        schemeOneCost.storage.originCost +
        schemeOneCost.transcode.originCost;
      const targetCost =
        schemeOneCost.cdn.targetCost +
        schemeOneCost.storage.targetCost +
        schemeOneCost.transcode.targetCost;
      setAssessmentOne({
        saveRate: (originCost - targetCost) / originCost,
        earning: originCost - targetCost,
        originCost,
        targetCost,
        originCostCdn: schemeOneCost.cdn.originCost,
        originCostTranscode: schemeOneCost.transcode.originCost,
        originCostStorage: schemeOneCost.storage.originCost,
        targetCostCdn: schemeOneCost.cdn.targetCost,
        targetCostTranscode: schemeOneCost.transcode.targetCost,
        targetCostStorage: schemeOneCost.storage.targetCost,
      });
      // 方案 2
      const { scale, transcodeCompress } = getScale(
        scene,
        targetQuality,
        originQuality,
        videoConfigs
      );
      // 方案二总费用 = 归一化系数 X CDN用量 X (1 - 转码压缩率) X CDN单价
      const schemeTwoCost =
        schemeOneCost.cdn.originCost * scale * (1 - transcodeCompress);
      setAssessmentTwo({
        saveRate: (originCost - schemeTwoCost) / originCost,
        earning: originCost - schemeTwoCost,
        originCost,
        targetCost: schemeTwoCost,
      });
    }
  };

  // 首次进入，使用默认值计算
  useEffect(() => {
    getAssessmentResult(formData);
  }, [formData, targetQuality, originQuality, scene]);

  return (
    <Row>
      <Col span="8">
        <BusinessForm formValue={formData} onSubmit={getAssessmentResult} />
      </Col>
      <Col span="16">
        <AssessmentResult
          assessmentOne={assessmentOne}
          assessmentTwo={assessmentTwo}
        />
      </Col>
    </Row>
  );
};

export default BusinessDataConfig;
